module.exports = __webpack_public_path__ + "static/media/chg9.4329ebbb.png";